import { IconInfoCircle } from '@/features/icons';
import Tooltip from '@/features/tooltip';
import { useVariantContextValues } from '../../context/use-variant-context-values';
function VendorDetailsDesktop() {
  const {
    vendorDetails
  } = useVariantContextValues('pdp');
  const {
    tooltipText,
    vendorText
  } = vendorDetails;
  const showTooltip = !!tooltipText && !!vendorText;
  if (!showTooltip && !vendorText) return null;
  return <div className='relative flex items-center gap-1.5 text-body-16 text-text-darkGray' data-sentry-component="VendorDetailsDesktop" data-sentry-source-file="desktop.tsx">
            {!!vendorText && <span>{vendorText}</span>}

            {showTooltip && <Tooltip className='left-[60%] w-[367px]' tooltipText={tooltipText}>
                    <IconInfoCircle className='h-5 w-5 text-alert-info-dark' />
                </Tooltip>}
        </div>;
}
export default VendorDetailsDesktop;